import { CommonModule } from '@angular/common';
import { RouterLink, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

export const CommonStandaloneImports = [
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  RouterLink
];
